import { cacheFirstConfig, http } from '@/core/helpers/axiosHelper';
import { SocialSecurityNumberMaskType } from '@nxtpeople/nxt-vue-library';

export class SocialSecurityNumberMaskTypeService {
   async getSocialSecurityNumberMaskTypes() {
      const response = await http.get<Array<SocialSecurityNumberMaskType>>(`/social-security-number-mask-types`, { ...cacheFirstConfig });
      return response.data;
   }

   async getSocialSecurityNumberMaskType() {
      throw Error('Method not implemented');
   }

   async postSocialSecurityNumberMaskType() {
      throw Error('Method not implemented');
   }

   async putSocialSecurityNumberMaskType() {
      throw Error('Method not implemented');
   }

   async deleteSocialSecurityNumberMaskType() {
      throw Error('Method not implemented');
   }
}
